export const colorsTheme = {
  white: '#FFFFFF',
  black: '#000000',
  danger: '#F2383A',

  'gradient-deg': '0deg',
  'gradient-primary': '#F00CFD',
  'gradient-secondary': '#B009F5',

  'primary-color': '#290B5D',
  'secondary-color': '#290B5D',
  'auxiliary-color': '#1A1A3B',

  'secondary-button-background': 'transparent',
  'secondary-button-background-hover': '#290B5D',
  'secondary-button-color': '#290B5D',
  'secondary-button-color-hover': '#FFFFFF',
  'secondary-button-border': '#290B5D',
  'secondary-button-border-hover': '#290B5D',

  'bg-color': '#FFFFFF',
  'bg-secondary-color': '#FFFFFF',
  'bg-auxiliary-color': '#343A40',

  'bg-circle-color': '#FFFFFF',
  'bg-circle-hover': '#290B5D',
  'bg-circle-text-color': '#000',
  'bg-circle-text-color-hover': '#FFFFFF',

  'filter-button-background': '#290B5D',
  'filter-button-color': '#FFFFFF',
  'filter-button-border': '#290B5D',
  'entry-message-color': '#290B5D',

  'bg-modal-color': '#343A40',

  'dark-color': '#3F3F3F',

  'text-primary': '#FFFFFF',
  'text-secondary': '#FFFFFF',
  'text-tertiary': '#FFFFFF',
  'text-gray': '#4F4F4F',

  'input-color': '#FFFFFF',
  'bg-input-color': '#FFFFFF',
  'info-color': '#6c757d',
  'disabled-color': '#6c757d',
  'card-color': '#495057',
  'modal-border-color': '#ADB5BD',
  'border-color': '#FFFFFF',

  'echeck-label-color': '#000',
  'echeck-border-color': '#D2D2D2',
  'echeck-text-color': '#000',
  'echeck-bar-color1': '#290B5D',
  'echeck-bar-color2': '#290B5D',
};
